import images from "./images";

const services = [
    {
        image: `${images.services_img_1}`,
        title: "Web Design",
        paragraph: " I design responsive react,php,Expressjs websites at an affordable price conveniently ."
        
    },
    {
        image: `${images.services_img_2}`,
        title: "Branding",
        paragraph: "Badges and uniform branding are now available at customers choice."
    },
    {
        image: `${images.services_img_3}`,
        title: "UX Design",
        paragraph: "Get the best user experience designs and know your preferred UX designer ."
    },
    {
        image: `${images.services_img_4}`,
        title: "Logo Create",
        paragraph: "Different kinds of logos and all brands are available Templates are also available."
    },
    {
        image: `${images.services_img_5}`,
        title: "Illustration",
        paragraph: "We now offer illustrations on how to go about different tech skills."
    },
    {
        image: `${images.services_img_6}`,
        title: "Graphics",
        paragraph: "All kinds of graphics design  posters, banners and many others are available."
    },
];

const works = [
    {
        image: `${images.work_img_1}`
    },
    {
        image: `${images.work_img_2}`
    },
    {
        image: `${images.work_img_3}`
    },
    {
        image: `${images.work_img_4}`
    },
    {
        image: `${images.work_img_5}`
    },
    {
        image: `${images.work_img_6}`
    },
];

const work_process = [
    {
        title: "Sketch",
        paragraph: "Design frame sketches and work schedule sketches"
    },
    {
        title: "Design",
        paragraph: "Hotel management system user interface designed and completed"
    },
    {
        title: "Develop",
        paragraph: "Hotel management system completed"
    },
    {
        title: "End-Product",
        paragraph: "Completed products which are available in my github account"
    },
];

const about_stats = [
    {
        image: `${images.stat_img_1}`,
        value: "1009",
        title: "Clients"
    },
    {
        image: `${images.stat_img_2}`,
        value: "11",
        title: "Projects"
    },
    {
        image: `${images.stat_img_3}`,
        value: "144",
        title: "Working Hours"
    },
    {
        image: `${images.stat_img_4}`,
        value: "17",
        title: "Awards"
    },
];

const testimonials = [
    {
        name: "Tyrone Kisienya",
        post: "Graphic Designer",
        paragraph: "A good friend of mine and a classmate. Very creative and always loves what he does"
    },
    {
        name: "Gitau Justus",
        post: "Web Developer",
        paragraph: "Good work a friend whom i always believe to compete with. Continue with the good work for the future is bright!."
    },
    {
        name: "Sure Wicklief",
        post: "Software Engineer",
        paragraph: "Good work friend and a classmate. You are always there to help. It's a team work for together we succeed."
    },
    {
        name: "Sheila Awuor",
        post: "Nurse",
        paragraph: "A good brother of mine. Continue with this good work and art. Always motivated in you."
    },
    {
        name: "Okumu Samson",
        post: "Network Engineer",
        paragraph: "Nice work brother we should embrace team work and code together."
    },
]

const logos = [
    {
        image: `${images.logo_img_1}`
    },
    {
        image: `${images.logo_img_2}`
    },
    {
        image: `${images.logo_img_3}`
    },
    {
        image: `${images.logo_img_4}`
    },
    {
        image: `${images.test_img_5}`
    },
    {
        image: `${images.test_img_6}`
    },
];

export {services, works, work_process, about_stats, testimonials, logos};
